module.exports = __webpack_public_path__ + "sj.svg?d08937cbcc45b5b72fdbca418a465986";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/sj.svg
// module id = 1610
// module chunks = 0